module.exports = {
  GREEN: '#16a500',
  BLUE: '#428bca',
  RED: '#E2062C',
  LIGHTBLUE: '#5bc0de',
  LIGHTRED: '#ff7f7f',
  YELLOW: '#ffcc00',
};
